module.exports = __webpack_public_path__ + "./fonts/Norms-Bold.ttf";